/**
 * Shared field wrapper for the Access forms.
 *
 * This app has no FormField component — existing modals inline label + input +
 * Tailwind classes at every call site. One small wrapper keeps the four Access
 * forms consistent and their error rendering identical, without introducing a
 * design-system component the rest of the app does not use.
 */

import type { ReactNode } from 'react';

interface AccessFormFieldProps {
  label: string;
  htmlFor?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: ReactNode;
}

const AccessFormField = ({ label, htmlFor, error, hint, required, children }: AccessFormFieldProps) => (
  <div>
    <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700 mb-1">
      {label}
      {required && <span className="text-danger-600 ml-0.5">*</span>}
    </label>
    {children}
    {hint && !error && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
    {error && <p className="mt-1 text-xs text-danger-600">{error}</p>}
  </div>
);

export default AccessFormField;
